// extracted by mini-css-extract-plugin
export var displayNone = "_qz-6";
export var imgContainer = "_qz-2";
export var overflowHidden = "_qz-3";
export var productInfoCardButtonContainer = "_qz-5";
export var productTitleText = "_qz-4";
export var rightArrow = "_qz-1";
export var rightArrowContainer = "_qz-0";